export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["व्यापार पूरा करने के बाद, इसे बंद कर दिया जाएगा। आंतरिक धनराशि उपयोगकर्ता को स्थानांतरित की जाएगी।"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्या आप सुनिश्चित हैं कि आप व्यापार पूरा करना चाहते हैं?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["हां, पूरा करें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नहीं, सक्रिय रखें"])}
}